"use client";

import { jsx, jsxs } from "react/jsx-runtime";
import { AutumnContext } from "./AutumnContext";
import { useEffect, useState } from "react";
import { useDialog } from "./hooks/useDialog";
const BaseAutumnProvider = ({
  client,
  children
}) => {
  const [entity, setEntity] = useState(null);
  const [pricingTableProducts, setPricingTableProducts] = useState(null);
  const [components, setComponents] = useState({});
  const [paywallProps, setPaywallProps, paywallOpen, setPaywallOpen] = useDialog(components.paywallDialog);
  const [
    productChangeProps,
    setProductChangeProps,
    productChangeOpen,
    setProductChangeOpen
  ] = useDialog(components.productChangeDialog);
  const [refetchCustomer, setRefetchCustomer] = useState(null);
  const [refetchPricingTable, setRefetchPricingTable] = useState(null);
  useEffect(() => {
    client.createCustomer({
      errorOnNotFound: false
    });
  }, []);
  return /* @__PURE__ */ jsxs(
    AutumnContext.Provider,
    {
      value: {
        // customer,
        refetchCustomer,
        setRefetchCustomer,
        entity,
        setEntity,
        refetchPricingTable,
        setRefetchPricingTable,
        client,
        paywallDialog: {
          props: paywallProps,
          setProps: setPaywallProps,
          open: paywallOpen,
          setOpen: setPaywallOpen,
          setComponent: (component) => {
            setComponents({
              ...components,
              paywallDialog: component
            });
          }
        },
        prodChangeDialog: {
          props: productChangeProps,
          setProps: setProductChangeProps,
          open: productChangeOpen,
          setOpen: setProductChangeOpen,
          setComponent: (component) => {
            setComponents({
              ...components,
              productChangeDialog: component
            });
          }
        }
      },
      children: [
        components.paywallDialog && /* @__PURE__ */ jsx(
          components.paywallDialog,
          {
            open: paywallOpen,
            setOpen: setPaywallOpen,
            ...paywallProps
          }
        ),
        components.productChangeDialog && /* @__PURE__ */ jsx(
          components.productChangeDialog,
          {
            open: productChangeOpen,
            setOpen: setProductChangeOpen,
            ...productChangeProps
          }
        ),
        children
      ]
    }
  );
};
export {
  BaseAutumnProvider
};
